import * as Sentry from '@sentry/browser'

import { showInstallPromotion } from '../components/InstallPromotion'
import { toast } from '../components/message'
import {
  buscaProdutos,
  checkCameraPermission,
  conectarSocketOlivo,
  confirmarPedido,
  retomaPedidoPIX,
  showButtonOrder,
  storeOrder,
} from '../mobile'
import {
  criaIdentificadorUsuarioQRCode,
  validaSessaoQRCode,
  verificarConfiguracaoQRCodeValida,
  sincronizarConfiguracaoQRCode,
  limparConfiguracaoQRCodeExpirada,
} from '../Modules/qrCode'
import { configuraProgramaFidelidade } from '../pages/ProgramaDeFidelidade/ProgramaDeFidelidade'
import { usuario } from '../usuario'
import {
  createElement,
  format,
  getUrlAction,
  sentryError,
  storage,
} from '../utils'
import { BuscaDadosEstabelecimento } from './components/DadosEstabelecimento'
import { getStatusEstabelecimento } from './components/StatusAbertura'

let estabelecimento = {
  dispositivo: window.navigator?.userAgent,
  idSocket: '',
  tituloDestaques: 'Destaques',
  sugestoesProdutos: [],
  agendamento: {
    ativo: false,
    intervaloDias: 0,
    intervaloMinutos: 0,
    somenteAgendamentos: false,
  },
  plano: {
    basico: false,
    itermediario: false,
    avancado: false,
  },
  faixamesa: '',
  fantasia: '',
  logo: '',
  qrCode: {
    ativo: false,
    apenasVisualizacao: false,
    modoSenha: false,
    nomeCliente: '',
    celularCliente: '',
    horasSessaoQRCode: 5,
    mesa: '',
    solicitaInformacoesClienteQRCode: false,
    obrigarLeituraDaComanda: false,
    modoTablet: false,
    acessoCamera: false,
    naoSolicitaMesaModoTablet: false,
  },
  cardapio: {
    visualizacao: false,
  },
  endereco: {
    coordenadas: '',
    bairro: '',
    logradouro: '',
    numero: '',
    cidade: '',
    estado: '',

    toString: () => {
      const enderecoValues = [
        estabelecimento.endereco.logradouro,
        estabelecimento.endereco.numero,
        estabelecimento.endereco.bairro,
        estabelecimento.endereco.cidade,
        estabelecimento.endereco.estado,
      ].filter((item) => item)

      return enderecoValues.join(',')
    },
  },
  urlServer: '',
  pagamento: {
    somenteDinheiro: false,
    metodos: [],
    online: false,
    toString: () => {
      let formasDePagamento = ''
      estabelecimento.pagamento.metodos.forEach((pagamento, index, array) => {
        if (pagamento.Descricao) {
          formasDePagamento += pagamento.Descricao
          if (index + 1 !== array.length) {
            formasDePagamento += ', '
          }
        }
      })
      return formasDePagamento
    },
  },
  intervaloProdutos: {
    ativo: false,
    intervalos: [],
    intervalosPromocao: [],
  },
  chavepix: '',

  pizza: {
    considerarSaborComValorMaior: false,
    pizzas: [],
  },
  valorMinimoPedido: 0,
  semTaxaEntrega: false,
  contato: {
    email: '',
    twitter: '',
    site: '',
    telefone: '',
    instagram: '',
    facebook: '',
  },
  descricaoTempoEntrega: '',
  tempoEntrega: '',
  informarcao: '',
  entrega: {
    tempoRetirada: 0,
    somenteEntregaBalcao: false,
    bairros: [],
    TemPedidoMinimoPorBairro: false,
    percentualTaxaEntrega: 0,
  },
  urlEmpresa: storage.get('urlEmpresa'),
  codigoBuscaBalcao: '',
  aberto: false,
  qrCodeAberto: false,
  mesa: '',
  comanda: {
    ativo: false,
    numero: '',
    utilizada: false,
    hash: '',
    hashLocal: '',
    hashAutorizado: '',
    QRCodeComandaModoSeguranca: false,
  },
  horarios: [],
  diasAbertos: [],
  programaFidelidade: {
    Descricao: '',
    PontosGanhos: 0,
    PontosUtilizados: 0,
    TipoLancamentoDesconto: 0,
    ValorGanho: 0,
    ValorGasto: 0,
    cliente: {
      pontos: 0,
      PontosUtilizados: 0,
    },
  },
  offline: false,
  deliveryAutomatico: false,
  confirmarPedido: false,
  taxaDeServico: 0,
  pixelFacebook: '',
  tipoEntrega: '',
  api: {
    maps: '',
    geocoder: '',
  },
  naoExibeCampoObsProdutoQRCode: false,
  naoExibeCampoObsProdutoDelivery: false,
  validaEstoque: false,
  ip: '',
  chaveAPIGoogleMaps: '',
  idSocket: '',
}

function inicializaEstabelecimento() {
  // Verifica se existe configuração QR Code salva e sinaliza para o controller
  verificaConfiguracaoQRCodeSalva()
  BuscaDadosEstabelecimento()
}

function verificaConfiguracaoQRCodeSalva() {
  try {
    // Usa a função do módulo qrCode.js para verificar configuração válida
    const configuracoesStorage = verificarConfiguracaoQRCodeValida()

    if (configuracoesStorage && configuracoesStorage.empresa === estabelecimento.urlEmpresa) {
      // Sinaliza para o body que estamos em modo QR Code para o CSS
      document.body.classList.add('cardapio-digital')

      // Define flags globais que podem ser acessadas pelo controller via JavaScript
      window.qrCodeConfig = {
        ativo: true,
        tipo: configuracoesStorage.tipo,
        isMesa: configuracoesStorage.parametrosOriginais?.isMesa || false,
        isComanda: configuracoesStorage.parametrosOriginais?.isComanda || false,
        isTablet: configuracoesStorage.parametrosOriginais?.isTablet || false,
        mesa: configuracoesStorage.mesa,
        comanda: configuracoesStorage.comanda,
        timestampAcesso: configuracoesStorage.timestampAcesso,
        empresa: configuracoesStorage.empresa
      }

      // Sincroniza todas as fontes de dados (localStorage, sessionStorage, cookie)
      sincronizarConfiguracaoQRCode(configuracoesStorage)

      console.log('Configuração QR Code válida encontrada e sincronizada')
    }
  } catch (e) {
    console.error('Erro ao verificar configuração QR Code salva:', e)
  }
}

// @ts-ignore
if (window.urlEstabelecimento) {
  // @ts-ignore
  estabelecimento.urlEmpresa = window.urlEstabelecimento
}

inicializaEstabelecimento()

axios
  .get(getUrlAction('Home', 'BuscaDadosEstab'), {
    params: {
      urlEmpresa: estabelecimento.urlEmpresa,
    },
  })
  .then(function ({ data }) {
    estabelecimento = { ...estabelecimento, ...data }

    {
      if (isDebug) {
        window.estabelecimento = estabelecimento
        window.usuario = usuario
      }
    }


    defineRedesSociais(data)

    removeLoaderApp()

    // Endereço
    if (data.Bairro) {
      estabelecimento.endereco.bairro = data.Bairro.Descricao
    }
    estabelecimento.endereco.logradouro = data.Logradouro
    estabelecimento.endereco.numero = data.Numero
    estabelecimento.endereco.cidade = data.cidade
    estabelecimento.endereco.estado = data.estado
    estabelecimento.endereco.coordenadas = data.Cordenadas
    // Fim Endereço

    estabelecimento.pizza.considerarSaborComValorMaior =
      data.considerarSaborComValorMaior

    carregaPedidoLocalStorage()

    // Com a logo e o nome do estabelecimento carregado, exibe a mensagem de instalação
    if (!estabelecimento.qrCode.ativo) {
      showInstallPromotion()
    }

    estabelecimento.cardapio.visualizacao =
      data.CardapioDeliveryReadOnly ||
      location.origin.includes('cardapio.mogomenu') ||
      verificaCardapioLeitura() || localStorage.getItem('somenteVisualizacao')

    localStorage.removeItem('somenteVisualizacao')
    if (estabelecimento.cardapio.visualizacao) {
      document.body.classList.add('cardapio-visualizacao')
      estabelecimento.qrCode.ativo = true
      window.configuracoesCardapio = {}


    }

    estabelecimento.pagamento.online = data.IsPagamentoOnline
    estabelecimento.entrega.somenteEntregaBalcao = data.SomenteEntregaBalcao
    estabelecimento.entrega.tempoRetirada = data.TempoRetirada

    estabelecimento.qrCode.apenasVisualizacao = data.CardapioDeliveryReadOnly
    estabelecimento.qrCode.apenasVisualizacao &&
      estabelecimento.qrCode.ativo && document.body.classList.add('qrcode-visualizacao')

    estabelecimento.qrCode.modoTablet = window.location.href.includes('tablet')

    estabelecimento.comanda.QRCodeComandaModoSeguranca =
      data.QRCodeComandaModoSeguranca

    estabelecimento.qrCode.horasSessaoQRCode =
      data.HorasSessaoQRCode == 0 ? 5 : data.HorasSessaoQRCode
    estabelecimento.qrCode.solicitaInformacoesClienteQRCode =
      data.SolicitaInformacoesClienteQRCode
    estabelecimento.qrCode.obrigarLeituraDaComanda = data.ObrigarLeituraDaComanda
    estabelecimento.qrCode.naoSolicitaMesaModoTablet = data.NaoSolicitaMesaModoTablet

    estabelecimento.chaveAPIGoogleMaps = data.ChaveAPIGoogleMaps

    estabelecimento.tipoEntrega = verificaTipoEntrega(data.TipoTaxaEntrega)

    window.estabelecimentoCarregado = true

    estabelecimento.validaEstoque = data.validaEstoqueCardapio

    estabelecimento.entrega.percentualTaxaEntrega = data.PercentualTaxaEntrega

    defineTempoEntrega()
    configuraCardapio()
    configuraCabecalhoEstabelecimento()
    if (typeof window.awaitCarregaEnderecos === 'function') {
      window.awaitCarregaEnderecos()
    }
    getStatusEstabelecimento()

    if (estabelecimento.qrCode.ativo) {
      const logoMenu = select('.logo-mesa')
      if (logoMenu) {
        logoMenu.setAttribute('src', estabelecimento.logo)
      }
    }

    exibeMensagemTax()

    if (!estabelecimento.DeliveryOffline) {
      configuraProgramaFidelidade()
    }

    configuraQRCode()

    configuraFacebookPixel()

  })
  .catch(function (error) {
    Sentry.captureException(error)
  })

const urlMarketPlace = storage.get('urlMarketPlace')

function verificaTipoEntrega(id) {
  if (id == 0) {
    return 'bairro'
  } else if (id == 1) {
    return 'raio'
  } else {
    return 'distancia'
  }
}
function configuraCardapio() {
  try {
    const isQRCode = typeof configuracoesCardapio === 'object'

    if (isQRCode) {
      estabelecimento.qrCode.ativo = true
    }

    // Busca configurações apenas do cookie
    let configuracoesStorage = verificarConfiguracaoQRCodeValida()

    if (configuracoesStorage) {
      if (configuracoesStorage.empresa != estabelecimento.urlEmpresa) {
        limparConfiguracaoQRCodeExpirada()
        configuracoesStorage = null
      }
    }

    if (estabelecimento.qrCode.ativo) {
      document.body.classList.add('cardapio-digital')

      // Preserva informações da URL original para validações no controller
      const urlOriginal = window.location.href
      const configuracoesCompletas = {
        ...configuracoesCardapio,
        urlOriginal: urlOriginal,
        parametrosOriginais: {
          isMesa: urlOriginal.includes('indexmesa') || configuracoesCardapio.tipo === 'mesa',
          isComanda: urlOriginal.includes('indexcomanda') || configuracoesCardapio.tipo === 'comanda',
          isTablet: urlOriginal.includes('tablet'),
          isVisualizacao: configuracoesCardapio.tipo === 'visualizacao'
        },
        timestampAcesso: new Date().getTime()
      }

      // Salva configurações apenas no cookie
      sincronizarConfiguracaoQRCode(configuracoesCompletas)

      if (configuracoesCardapio.tipo == 'visualizacao' || (estabelecimento.qrCode.ativo && urlEstabelecimento == "telepub")) {
        configuracoesCardapio.tipo = 'visualizacao'
        document.body.classList.add('qrcode-visualizacao')
        return
      }

      estabelecimento.comanda.numero = configuracoesCardapio.comanda
      // Hash estável do QR Code da comanda (quando o estabelecimento usa hash no lugar do número).
      // É reenviado ao lançar o pedido para o servidor resolver/validar a comanda pelo hash.
      estabelecimento.comanda.hashQRCode = configuracoesCardapio.comandaHash
      estabelecimento.mesa = configuracoesCardapio.mesa
      estabelecimento.qrCode.modoSenha = configuracoesCardapio.tipo == 'senha'
      estabelecimento.comanda.ativo = configuracoesCardapio.tipo == 'comanda'

      const title = select('.mesa-container h1')
      const botaoSairQRCode = select('#menu-sair-QRcode')

      if (botaoSairQRCode) {
        botaoSairQRCode.addEventListener('click', () => {
          // Usa a função do módulo qrCode.js para limpar todas as configurações
          limparConfiguracaoQRCodeExpirada()
          window.location =
            window.location.origin + '/' + estabelecimento.urlEmpresa
        })
      }

      if (estabelecimento.qrCode.modoSenha) {
        title.textContent = estabelecimento.fantasia
        botaoSairQRCode.remove()
      } else if (estabelecimento.comanda.ativo) {
        title.textContent = 'Comanda ' + estabelecimento.comanda.numero
      } else {
        title.textContent = 'Mesa ' + estabelecimento.mesa
      }

      usuario.identificadorQRCode = criaIdentificadorUsuarioQRCode()
    } else if (configuracoesStorage) {
      validaSessaoQRCode(configuracoesStorage.ticks, estabelecimento)

      // Se após validar foi ativado o modo QRCode
      if (estabelecimento.qrCode.ativo) {
        configuracoesCardapio = configuracoesStorage
        configuraCardapio()
      }
      return
    }
    const marketplaceButton = select('#marketplace')
    if (!estabelecimento.qrCode.modoSenha) {
      if (marketplaceButton) {
        marketplaceButton.remove()
      }

      if (!isDebug) {
        window.onbeforeunload = function (event) {
          if (!select('#message-box-login') && !select('.mensagem-login')) {
            event.returnValue = 'Tem certeza que deseja sair da página?'
          }
        }
      }
    } else {
      if (marketplaceButton) {
        marketplaceButton.style.display = 'flex'

        marketplaceButton.addEventListener('click', () => {
          window.location.href =
            location.origin +
            `/home/marketplace?urlMarketPlace=${urlMarketPlace}`
        })
      }
    }

    if (
      estabelecimento.comanda.ativo &&
      estabelecimento.comanda.QRCodeComandaModoSeguranca
    ) {
      const configuracoesComanda = configuracoesCardapio.hashComanda
      if (configuracoesComanda) {
        const parsedConfig =
          typeof configuracoesComanda === 'string'
            ? JSON.parse(configuracoesComanda)
            : configuracoesComanda
        setConfig(parsedConfig)
        localStorage.removeItem('HashComanda')
      } else {
        axios
          .get(getUrlAction('Home', 'ConsultaComanda'), {
            params: {
              urlEmpresa: estabelecimento.urlEmpresa,
              strComanda: estabelecimento.comanda.numero,
            },
          })
          .then(({ data }) => {
            setConfig(data)
          })
          .catch((e) => {
            sentryError.exception('Erro ao carregar configurações da comanda')
          })
      }

      function setConfig(config) {
        const { hash, utilizado } = config
        estabelecimento.comanda.ativo = true
        estabelecimento.comanda.hash = hash
        estabelecimento.comanda.utilizada = utilizado

        if (!utilizado) {
          storage.setItem('hashLocal', hash)
          estabelecimento.comanda.hashLocal = hash
        } else {
          const hashLocal = storage.get('hashLocal')
          estabelecimento.comanda.hashLocal = hashLocal

          const hashAutorizado = storage.get('hashLocal-autorizado')
          if (hashAutorizado) {
            estabelecimento.comanda.hashAutorizado = hashAutorizado
            estabelecimento.comanda.hashLocal = hashAutorizado
          }
        }

        conectarSocketOlivo()
      }
    } else {
      conectarSocketOlivo()
    }

    if (estabelecimento.qrCode.ativo && estabelecimento.qrCode.modoTablet) {
      document.body.classList.add('modo-tablet')

      const mesaMenuTitle = select('.mesa-container h1')

      if (!estabelecimento.qrCode.mesa && !estabelecimento.qrCode.naoSolicitaMesaModoTablet) {
        // já existe
        const alreadyExists = select('.tablet-escolher-mesa')
        if (alreadyExists) {
          return
        }

        const containerEscolherMesa = createElement(
          'div',
          {
            class:
              'tablet-escolher-mesa bg-white fixed font-20 font-500 gap-16 inset-0 p-12 tablet-escolher-mesa z-index-max',
          },
          `
                <div class="flex-center flex-column h-100 gap-16" style="max-width: 43rem;margin: auto;">
                    <img src="./images/mesa.png" class="w-100" style="max-width: 20rem;margin-bottom: 1rem;">
                    <div style="margin-bottom: 5rem;">Informe o número da mesa</div>
                    <input type="number" id="numero-mesa" class="input text-center" placeholder="Mesa">
                    <span id="error" class="font-red font-14 empty-hiddem"></span>
                    <button class="hover-bg-blue cursor-pointer btn-primary-blue font-14 font-600 w-100">Confirmar</button>
                </div>`,
        )

        document.body.appendChild(containerEscolherMesa)

        const input = select('#numero-mesa', containerEscolherMesa)
        const button = select('button', containerEscolherMesa)
        const error = select('#error', containerEscolherMesa)

        button.addEventListener('click', () => {
          error.innerHTML = ''

          let mesa = input.value
          if (mesa) {
            if (mesa < 10 && mesa.length == 1) {
              mesa = '0' + mesa
            }

            estabelecimento.qrCode.mesa = mesa
            localStorage.setItem('mesa-tablet', mesa)
            containerEscolherMesa.remove()

            mesaMenuTitle.textContent = `Mesa ${mesa}`

            toast('Mesa definida com sucesso!')
          } else {
            error.innerHTML = 'Informe o número da mesa'
          }
        })
      } else {
        const btnMenu = select('#menu')
        btnMenu.style.display = 'none'
        mesaMenuTitle.textContent = `Mesa`
      }

      // mogomarket informa a comanda digitando (ver mobile.js), não usa a câmera
      if (estabelecimento.urlEmpresa !== 'mogomarket') {
        checkCameraPermission()
      }
    }
  } catch (e) {
    console.error(e)
  }
}

function configuraFacebookPixel() {
  if (estabelecimento.pixelFacebook) {
    const script = document.createElement('script')
    script.innerHTML = estabelecimento.pixelFacebook

    document.head.appendChild(script)

    script.onload = function () {
      try {
        fbq('track', 'PageView')
      } catch (e) {
        console.error('Erro ao rastrear a PageView:', e)
      }
    }

    script.onerror = function () {
      console.error('Erro ao carregar o script do Facebook Pixel.')
    }
  }
}

function dialog(object) {
  const dialogEl = document.createElement('div')
  dialogEl.classList = 'dialog'
  dialogEl.innerHTML = `
         <div class="dialog-background" ></div>
         <div class="dialog-container ${object.classList ? object.classList : ''
    }">
             <header>
                <span>${object.title}</span>
                ${object.close
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      : ''
    }
            </header>
            <div>${object.body}</div>
        </div>`
  const dialogContainer = select('#dialog')
  dialogContainer.appendChild(dialogEl)

  $('#dialog header svg').on('click', () => {
    dialogContainer.innerHTML = ''
  })

  if (object.function) {
    object.function()
  }
}

function exibeMensagemTax() {
  if (estabelecimento.entregaGratis && !estabelecimento.qrCode.ativo) {
    const msgEntregaGratis = document.createElement('div')
    msgEntregaGratis.innerHTML = `
        <div class="mensagem-estab-taxaentrega"> 
            <div class="mensagem-estab-taxaentrega--content">Pedidos a partir de ${format.money(estabelecimento.entregaGratis)} entrega grátis</div> 
            <div class="mensagem-estab-taxaentrega--close">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.9175 1.34381L1.91748 13.3438" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.91748 1.34381L13.9175 13.3438" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>                   
        </div>`
    const wrapper = select('.mensagem-estab-taxaentrega-wrapper')
    wrapper && wrapper.appendChild(msgEntregaGratis)
    wrapper
      .querySelector('.mensagem-estab-taxaentrega--close')
      .addEventListener('click', () => {
        msgEntregaGratis.remove()
      })
  }
}

try {
  axios
    .get(getUrlAction('Home', 'GetFaixaMesas'), {
      params: {
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then(function ({ data }) {
      const loader = select('.app-loader')
      loader && loader.remove()

      if (data && Array.isArray(data) && data.length > 0) {
        let numeroInicial
        let numeroFinal

        data.forEach((faixa) => {
          if (!numeroInicial && !numeroFinal) {
            numeroInicial = faixa.NumeroMesaInicial
            numeroFinal = faixa.NumeroMesaFinal
          } else {
            if (faixa.NumeroMesaInicial < numeroInicial) {
              numeroInicial = faixa.NumeroMesaInicial
            }

            if (faixa.NumeroMesaFinal > numeroFinal) {
              numeroFinal = faixa.NumeroMesaFinal
            }
          }
        })

        estabelecimento.faixamesa = {
          NumeroMesaInicial: numeroInicial,
          NumeroMesaFinal: numeroFinal,
        }
      }
    })
    .catch(function (error) {
      const errorName = (error.name || '').replace(' ', '').toLowerCase()
      if (errorName != 'networkerror') {
        throw new Error(estabelecimento.urlEmpresa + ' | ' + error)
      }
    })
} catch (error) {
  const errorName = (error.name || '').replace(' ', '').toLowerCase()
  if (errorName != 'networkerror') {
    throw new Error(estabelecimento.urlEmpresa + ' | ' + error)
  }
}

if (
  window.location.href.includes('app.olivodelivery.com.br') &&
  !estabelecimento.qrCode.ativo
) {
  window.location.href = window.location.href.replace(
    'app.olivodelivery.com.br',
    'app.mogomenu.com.br',
  )
}

function configuraQRCode() {
  if (
    estabelecimento.qrCode.ativo &&
    !estabelecimento.qrCode.modoSenha &&
    isDebug
  ) {
    const tutorial = storage.get('tutorial-garcon')

    if (!tutorial && !estabelecimento.qrCode.apenasVisualizacao) {
      const searchArea = select('#search-area')
      const navBar = select('#nav-bar')
      navBar.insertBefore(wrapper, searchArea)

      localStorage.setItem('tutorial-garcon', true)
    }
  }
}

export { estabelecimento }

function removeLoaderApp() {
  const loader = select('.app-loader')
  loader && loader.remove()
}

function defineTempoEntrega() {

  try {

    if (estabelecimento.entrega.somenteEntregaBalcao) {
      if (estabelecimento.entrega.tempoRetirada && estabelecimento.entrega.tempoRetirada > 0) {
        estabelecimento.descricaoTempoEntrega = `${estabelecimento.entrega.tempoRetirada} minutos`
      } else {
        estabelecimento.descricaoTempoEntrega = 'Somente retirada no balcão'
      }

      return
    }

    if (estabelecimento.tempoEntrega) {
      estabelecimento.descricaoTempoEntrega = estabelecimento.tempoEntrega
      estabelecimento.tempoEntrega = estabelecimento.tempoEntrega.split('-')

      if (estabelecimento.tempoEntrega.length > 0) {
        if (estabelecimento.tempoEntrega[0]) {
          estabelecimento.tempoEntrega[0] =
            estabelecimento.tempoEntrega[0].replace(/\D/gim, '')
        }

        if (estabelecimento.tempoEntrega[1]) {
          estabelecimento.tempoEntrega[1] =
            estabelecimento.tempoEntrega[1].replace(/\D/gim, '')
        }

        if (estabelecimento.tempoEntrega[0] == '') {
          estabelecimento.tempoEntrega = undefined
        }
      }
    }
  } catch (e) {
    sentryError.exception(estabelecimento.urlEmpresa + ' - ' + e)
  }
}

function defineRedesSociais(data) {
  const iconeTwitter = select('#twitter')
  const iconeFacebook = select('#facebook')
  const iconeInstagram = select('#instagram')

  if (data.contato.instagram && iconeInstagram) {
    iconeInstagram.setAttribute('href', data.contato.instagram)
  } else {
    iconeInstagram && iconeInstagram.remove()
  }

  if (data.contato.facebook && iconeFacebook) {
    iconeFacebook.setAttribute('href', data.contato.facebook)
  } else {
    iconeFacebook && iconeFacebook.remove()
  }

  if (data.contato.twitter && iconeTwitter) {
    iconeTwitter.setAttribute('href', data.contato.twitter)
  } else {
    iconeTwitter && iconeTwitter.remove()
  }
}

function carregaPedidoLocalStorage() {
  // Carrega o pedido armazenado no storage
  const pedido = storage.get(`pedido-mobile-${estabelecimento.urlEmpresa}`)
  const configuracoesPagamentoQRCode = pedido?.configuracoesPagamentoQRCode
  delete pedido?.configuracoesPagamentoQRCode

  if (pedido) {
    const dataPedido = new Date(
      (pedido.Itens[0].CodTicks - 621355968000000000) / 10000,
    )
    const diferencaTempo = new Date().getTime() - dataPedido.getTime()
    if (diferencaTempo / (1000 * 60 * 60) > 5) {
      storage.remove(`pedido-mobile-${estabelecimento.urlEmpresa}`)
    } else {
      for (const key in pedido) {
        storeOrder[key] = pedido[key]
      }

      if (configuracoesPagamentoQRCode) {
        // Consulta o servidor antes de reexibir o QR Code: se o pagamento caiu
        // enquanto o navegador estava fechado, o pedido já foi efetivado pela
        // reconciliação e o cliente vê a confirmação direto.
        retomaPedidoPIX(configuracoesPagamentoQRCode)
      } else {
        showButtonOrder(true)
      }
    }
  }
}

function configuraCabecalhoEstabelecimento() {
  const logo = select('#cardapio .logo-container img')
  if (logo) {
    logo.setAttribute('src', estabelecimento.logo)
    logo.classList = ''
  }

  const fantasiaText = select('#estabelecimento-fantasia')
  fantasiaText && (fantasiaText.textContent = estabelecimento.fantasia)

  const tempoEntregaWrapper = select('#estabelecimento-entrega')
  if (
    estabelecimento.descricaoTempoEntrega &&
    tempoEntregaWrapper &&
    !estabelecimento.qrCode.ativo
  ) {
    tempoEntregaWrapper.innerHTML = `
        <div class="u-flex-column u-flex-start u-margin-r-1">
            <div class="u-nowrap u-font-gray-dark u-font-12">${estabelecimento.entrega.somenteEntregaBalcao ? "Retirada" : "Entrega"}</div>
            <div class="u-font-gray-dark u-font-12 u-font-w-450">${estabelecimento.descricaoTempoEntrega}</div>
        </div>`
  }

  if (estabelecimento.endereco.cidade) {
    const enderecoText = select('#estabelecimento-endereco')
    enderecoText &&
      (enderecoText.textContent =
        estabelecimento.endereco.cidade +
        (estabelecimento.endereco.estado
          ? ', ' + estabelecimento.endereco.estado.toUpperCase()
          : ''))
  }
}

axios.get('https://api.ipify.org?format=json').then(({ data }) => {
  try {
    estabelecimento.ip = data.ip
  } catch (e) {
    sentryError.exception(e)
  }
})

function verificaCardapioLeitura() {
  const ticks = storage.get('cardapio-leitura')
  if (ticks) {
    // verifica se o acesso é nas ultimas 12 horas
    if (new Date(ticks).getTime() + 43200000 > new Date().getTime()) {
      return true
    } else {
      storage.remove('cardapio-leitura')
      return false
    }
  } else {
    return false
  }
}

/**
 * Guarda contra "pedido na base errada": o cookie de login é único por domínio,
 * então uma aba parada no cardápio A continua funcionando depois que o cliente
 * loga no cardápio B em outra aba — ou volta pra A pelo botão voltar (bfcache),
 * que não passa pelo servidor. Nesse estado a tela é de A e a sessão é de B, e o
 * pedido de A ia parar na base de B.
 *
 * Ao voltar pra tela, confere o estabelecimento da sessão com o cardápio aberto e
 * recarrega quando divergir — o Home/Index desloga e devolve o cliente ao cardápio
 * certo. A sacola continua no localStorage. O servidor também recusa o pedido
 * divergente (PedidoController.TenantDivergente); isto aqui só avisa antes.
 */
function vigiaSessaoEstabelecimento() {
  let verificando = false
  let recarregando = false
  let ultimaVerificacao = 0

  const verificaSessao = () => {
    if (verificando || recarregando) return
    if (!estabelecimento.urlEmpresa) return
    // Evita rajada de chamadas quando o navegador dispara os dois eventos juntos.
    if (Date.now() - ultimaVerificacao < 5000) return

    verificando = true
    ultimaVerificacao = Date.now()

    axios
      .get(getUrlAction('Home', 'SessaoEstabelecimento'))
      .then(({ data }) => {
        const sessao = typeof data === 'string' ? JSON.parse(data) : data
        if (!sessao || !sessao.autenticado || !sessao.dbName) return

        if (sessao.dbName.toLowerCase() !== String(estabelecimento.urlEmpresa).toLowerCase()) {
          // Um recarregamento por divergência: se o Home/Index não resolver
          // (rota sem urlEmpresa, por exemplo), não entra em loop de reload —
          // o SalvaPedido ainda recusa o pedido divergente.
          const marca = `sessao-divergente-${estabelecimento.urlEmpresa}-${sessao.dbName}`
          if (sessionStorage.getItem(marca)) return
          sessionStorage.setItem(marca, '1')

          recarregando = true
          toast('Você entrou em outro estabelecimento. Recarregando o cardápio...')
          setTimeout(() => location.reload(), 2000)
        }
      })
      .catch(() => {
        // Falha de rede não pode travar o cardápio: o servidor ainda recusa o
        // pedido divergente no SalvaPedido.
      })
      .then(() => {
        verificando = false
      })
  }

  // `persisted` = página restaurada do bfcache (botão voltar), que não refaz a
  // validação de sessão do servidor.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      verificaSessao()
    }
  })

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      verificaSessao()
    }
  })
}

vigiaSessaoEstabelecimento()
